// extracted by mini-css-extract-plugin
module.exports = {"team":"Team-module--team--_-xLh","teamMember":"Team-module--teamMember--MWcRF","fullSquad":"Team-module--fullSquad--2jqFF","fullSquadTitle":"Team-module--fullSquadTitle--2QnUy"};